/**
 * @section 4.2.1.3
 */
import { Theme } from "@material-ui/core";
import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
const useStyles = makeThemedStyles("SearchResultRow", (theme: Theme) => {
  return {
    resultCol1: {
      width: "55px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      maxHeight: "2.3em",
    },
    resultNameStack: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    resultNameRow: {
      width: "100%",
      fontSize: "11px",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      fontWeight: "bold",
      color: "rgba(16, 41, 117, 1)",
    },
    resultTypeRow: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      color: "#777",
    },
    resultSCName: {
      display: "inline-flex",
    },
    resultTypeName: {
      display: "inline-flex",
    },
    resultRow: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
      color: "black",
      cursor: "pointer",
      padding: "2px",
    },
  };
});
const SearchResultRow = (props: {
  value: ICardElementWithChildren;
  onNavigate?: (value: ICardElementWithChildren) => void;
}) => {
  const classes = useStyles();
  const { value } = props;
  return (
    <div
      className={classes.resultRow}
      role="button"
      tabIndex={0}
      onKeyDown={() => {}}
      onClick={() => {
        if (props.onNavigate) {
          props.onNavigate(value);
        }
      }}
    >
      <div
        style={{
          background: `linear-gradient(#${value.rangecolor}64 20%, #${value.rangecolor}44)`,
          border: `1px solid #${value.rangecolor}64`,
          color: `#330000f7`,
          borderRadius: "5px",
          display: "inline-flex",
          textShadow: "0px 1px 1px white",
        }}
        className={classes.resultCol1}
      >
        {value.PERF_prettyvalue || value.PERF_W_prettyvalue || "-"}
      </div>
      <div className={classes.resultNameStack}>
        <div className={classes.resultNameRow}>{value.name}</div>
        <div className={classes.resultTypeRow}>
          <div className={classes.resultSCName}>{value.scorecardname}</div>
          <div className={classes.resultTypeName}> ({value.typename})</div>
        </div>
      </div>
    </div>
  );
};
export default SearchResultRow;
